<template>
    <b-modal title="Add Advocate"
        header-bg-variant="success"
        header-text-variant="light"
        size="lg"
        :visible="true"
        centered
        @ok="addAdvocate"
        @hide="modalClose">
        <b-form>
            <b-form-group label="Advocate Name" label-class='addpersonlabel' label-for='Advocate Name'>
                <b-form-input size="lg" type="text" name="Advocate Name" v-model="advocate.name" v-validate="'required'"/>
                <span v-show="inputValidationErrors.has('Advocate Name')" class="text-info">{{ inputValidationErrors.first('Advocate Name') }}</span>
            </b-form-group>
            <b-form-group label="Organization"
                label-class="addpersonlabel"
                label-for="Organization">
                <b-form-select
                  id="organization"
                  v-validate="'required'"
                  data-vv-name="Organization"
                  data-vv-as="Organization"
                  :options="organizationOptions"
                  v-model="advocate.organization">
                </b-form-select>
                <span v-show="inputValidationErrors.has('Organization')" class="text-info">{{ inputValidationErrors.first('Organization') }}</span>
            </b-form-group>
            <b-form-group v-if="advocate.organization === 'Other'"
                label="Other Organization"
                label-for="Other Organization">
                <b-form-input size="lg" type="text" name="Other Organization" v-model="advocate.organization_otherText" v-validate="'required'"/>
                <span v-show="inputValidationErrors.has('Other Organization')" class="text-info">{{ inputValidationErrors.first('Other Organization') }}</span>
            </b-form-group>
            <b-form-group label="Email" label-class='addpersonlabel' label-for='Email'>
                <b-form-input size="lg" type="text" name="Email" v-model="advocate.email" v-validate="'required'"/>
                <span v-show="inputValidationErrors.has('Email')" class="text-info">{{ inputValidationErrors.first('Email') }}</span>
            </b-form-group>
            <b-form-group label="Phone" label-class='addpersonlabel' label-for='phone'>
                <b-form-input size="lg" type="text" name="phone" v-model="advocate.phone"/>
            </b-form-group>
        </b-form>
        <template #modal-footer>
            <div class="w-100">
                <b-button
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="addAdvocate">
                    Submit
                </b-button>
                <b-button
                    variant="link"
                    size="sm"
                    class="float-right"
                    @click="modalClose">
                    Cancel
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'add-advocate-modal',
  props: {
    personId: Number,
    person: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      personState: ''
    }
  },
  computed: {
    ...mapGetters({
      advocate: 'getCreateAdvocate',
      organizations: 'getAllOrganizations'
    }),
    organizationOptions () {
      console.log(JSON.stringify(this.organizations.map(o => ({ state: o.personState, title: o.title }))))
      let organizationList = this.organizations
        .filter((org) => org.mailingStateAbbreviation === this.personState)
        .map(org => {
          return { value: org.id, text: org.title }
        })

      organizationList = _.sortBy(organizationList, 'title')
      return [...organizationList, { value: 'Other', text: 'Other' }]
    }
  },
  methods: {
    addAdvocate: function () {
      this.$validator.validate().then((res) => {
        if (res) {
          if (this.advocate.organization === 'Other') {
            this.advocate.organization = null
          }
          this.$store.dispatch('createAdvocate', this.advocate)
          this.$emit('modalClose')
        }
      })
    },
    modalClose: function () {
      this.$emit('modalClose')
    }
  },
  async created () {
    this.advocate.person = this.personId
    await this.$store.dispatch('getOrganizations', {
      filters: {
        excludeTestOrg: true
      }
    })
    const owningOrg = this.person.organizationOwner
    if (owningOrg) {
      this.personState = owningOrg.mailingStateAbbreviation
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/t1/AddAdvocateModal.vue